import i18n from "i18next";
import {initReactI18next} from "react-i18next";

const resources = {
  en: {
    translation: {
      auth: "Authentication",
      aFourDigitVerificationCode: "A four-digit verification code will be sent to your phone number",
      continue: "Continue",
      verification: "Verification",
      enterTheFourDigitCode: "Enter the four-digit code sent to your phone number for verification",
      didNotGetTheCode: "Didn't get the code?",
      sendAgain: "Send again",
      byContinueYouAgree: "By continuing, you agree to the",
      privacyPolicy: "Privacy Policy",
      termsOfUse: "Terms of Use",
      createPin: "Create a PIN",
      pinConfirmation: "PIN confirmation",
      comeUpWithAPin: "Come up with a 4-digit PIN that will be used to access the account",
      confirmThePin: "Confirm the PIN entered on the previous screen",
      pinsDoNotMatch: "PINs do not match",
      back: "Back",
      whoAreYou: "Who are you?",
      specifyYourRole: "Specify your role in working with the application",
      doctor: "Doctor",
      treatingThisIsMyMainGoal: "Treating this is my main goal",
      patient: "Patient",
      iNeedASolutionToTheProblem: "I need a solution to the problem",
      welcomeBack: "Welcome back",
      enterYourPin: "Enter your PIN",
      welcome: "Welcome",
      appointments: "Appointments",
      patientSearch: "Patient search",
      medecines: "Medecines",
      notes: "Notes",
      aiAssist: "AI Assist",
      startReception: "Start Reception",
      startReceptionDesc: "Start the reception recording.",
      startReceptionDesc2: "Get the text version for processing.",
      gptChatBotBySubscription: "GPT chat bot by subscription",
      searchByMedicine: "Search by medicine",
      comparisonOfMedicines: "Comparison of medicines",
      protocols: "Protocols",
      protocol: "Protocol",
      chatWithDanaAi: "Chat with Dana AI",
      realTimeTranslate: "Real-time translation",
      personalInformation: "Personal information",
      uploadYourPhoto: "Upload your photo",
      save: "Save",
      dateOfBirth: "Date of birth",
      sip: "SIP",
      position: "Position",
      nameString: "Name",
      lastName: "Last name",
      marketingAuthorizationStatus: "Marketing Authorization Status",
      authorized: "Authorized",
      suspended: "Suspended",
      revoked: "Revoked",
      nonSubstitutedMedicines: "Non substituted medicines",
      biologicals: "Biologicals",
      narrowTherapeuticMargin: "Narrow therapeutic margin",
      forTheRespiratorySystem: "For the respiratory system",
      yourChose: "Your chose",
      cleanAll: "Clean all",
      search: "Search",
      available: "Available",
      notAvailable: "Not available",
      noResults: "No results were found \n" +
        "for your query",
      noResultsShort: "No results found",
      tryChangingTheRequest: "Try changing the request",
      typesOfAnamnesis: "Types of anamnesis",
      toStartTheConsultation: "To start the consultation, choose its type",
      selectTheTypeOfAnamnesis: "Select the type of anamnesis",
      addToCompare: "Add to compare",
      filters: "Filters",
      characteristics: "Characteristics",
      company: "Company",
      pharmaceuticalDoseForms: "Pharmaceutical dose forms",
      activeIngredients: "Active ingredients",
      routesOfAdministration: "Routes of administration",
      strength: "Strength",
      excipients: "Excipients",
      atcCodes: "Atccodes",
      selectTypeOfAnamnesis: "Select the type of anamnesis",
      removeFromInteractions: "Remove from interactions",
      danaAssist: "Dana Assist",
      doYouHaveAQuestionForMe: "Do you have a question for me?",
      diagnosticImaging: "Diagnostic imaging",
      medicalCalculators: "Medical Calculators",
      treatmentFormulation: "Treatment Formulation",
      differentialCaseDiagnosis: "Differential case diagnosis",
      laboratoryResultsInterpretation: "Laboratory results interpretation",
      message: "Message",
      deleteNote: "Delete note",
      comparison: "Comparison",
      toStartComparisonSelectMedicines: "To start the comparison, select medicines",
      goToComparison: "Go to comparison",
      addMedicinesToCompare: "Add medicines to compare",
      noInteractionsDescribed: "There are no interactions described for this combination",
      highDanger: "High danger",
      mediumDanger: "Medium danger",
      lowDanger: "Low danger",
      effect: "Effect",
      importance: "Importance",
      mechanism: "Mechanism",
      informationSource: "Information source",
      objectives: "Objectives",
      links: "Links",
      anamnesis: "Anamnesis",
      turnOffNotifications: "Turn off notifications",
      turnOnNotifications: "Turn on notifications",
      blockThePatient: "Block the patient",
      unBlockThePatient: "Unblock the patient",
      shareAnamnesis: "Share anamnesis",
      email: "Email",
      hasUnfinishedAnamnesis: "Has unfinished anamnesis",
      continueAnamnesis: "Continue anamnesis",
      acceptChange: "Accept change",
      endAnamnesis: "End anamnesis",
      addPatientToChat: "Add a patient to the chat",
      startChatWithPatient: "To start a chat with a patient,\n find them by phone or SIP number",
      or: "or",
      patientNotFound: "Patient not found",
      giveNameToPatient: "You can give a name to the patient",
      selectPatientToCompleteAppointment: "Select a patient to complete the appointment",
      skip: "Skip",
      surname: "Surname",
      specialtyExternalConsultationReport: "Specialty External Consultation Report",
      primaryCareClinicalReport: "Primary Care Clinical Report",
      emergencyReport: "Emergency Report",
      summaryClinicalHistory: "Summary Clinical History",
      firstVisitDetailedSoap: "First Visit (Detailed SOAP)",
      firstVisitConciseSoap: "First Visit (Concise SOAP)",
      successiveVisitsEvolution: "Successive Visits (Evolution)",
      nursingCareReport: "Nursing Care Report",
      socialWorkerReport: "Social Worker Report",
      recipe: "Recipe",
      error: "Error",
      process: "Process",
      synchronousTranslator: "Synchronous translator",
      enterTextToTranslate: "Enter text to translate",
      clickOnMicrophoneToStart: "Click on the microphone to start",
      settings: "Settings",
      theme: "Theme",
      language: "Language",
      changePhone: "Change phone number",
      pinChange: "PIN change",
      signOut: "Sign out",
      numberChange: "Number change",
      enterCurrentPhoneForVerification: "Enter your current phone number for verification",
      enterNewPhoneForVerification: "Enter your new phone number for verification",
      copy: "Copy",
      en: "English",
      pt: "Portuguese",
      ua: "Ukrainian",
      es: "Spanish",
      lightTheme: "Light theme",
      darkTheme: "Dark theme",
      systemTheme: "System theme",
    },
  },
  uk: {
    translation: {
      auth: "Authentication",
      aFourDigitVerificationCode: "A four-digit verification code will be sent to your phone number",
      continue: "Continue",
      verification: "Verification",
      enterTheFourDigitCode: "Enter the four-digit code sent to your phone number for verification",
      didNotGetTheCode: "Didn't get the code?",
      sendAgain: "Send again",
      byContinueYouAgree: "By continuing, you agree to the",
      privacyPolicy: "Privacy Policy",
      termsOfUse: "Terms of Use",
      createPin: "Create a PIN",
      pinConfirmation: "PIN confirmation",
      comeUpWithAPin: "Come up with a 4-digit PIN that will be used to access the account",
      confirmThePin: "Confirm the PIN entered on the previous screen",
      pinsDoNotMatch: "PINs do not match",
      back: "Back",
      whoAreYou: "Who are you?",
      specifyYourRole: "Specify your role in working with the application",
      doctor: "Doctor",
      treatingThisIsMyMainGoal: "Treating this is my main goal",
      patient: "Patient",
      iNeedASolutionToTheProblem: "I need a solution to the problem",
      welcomeBack: "Welcome back",
      enterYourPin: "Enter your PIN",
      welcome: "Welcome",
      appointments: "Appointments",
      patientSearch: "Patient search",
      medecines: "Medecines",
      notes: "Notes",
      aiAssist: "AI Assist",
      startReception: "Start Reception",
      startReceptionDesc: "Start the reception recording.",
      startReceptionDesc2: "Get the text version for processing.",
      gptChatBotBySubscription: "GPT chat bot by subscription",
      searchByMedicine: "Search by medicine",
      comparisonOfMedicines: "Comparison of medicines",
      protocols: "Protocols",
      protocol: "Protocol",
      chatWithDanaAi: "Chat with Dana AI",
      realTimeTranslate: "Real-time translation",
      personalInformation: "Personal information",
      uploadYourPhoto: "Upload your photo",
      save: "Save",
      dateOfBirth: "Date of birth",
      marketingAuthorizationStatus: "Marketing Authorization Status",
      authorized: "Authorized",
      suspended: "Suspended",
      revoked: "Revoked",
      nonSubstitutedMedicines: "Non substituted medicines",
      biologicals: "Biologicals",
      narrowTherapeuticMargin: "Narrow therapeutic margin",
      forTheRespiratorySystem: "For the respiratory system",
      yourChose: "Your chose",
      cleanAll: "Clean all",
      search: "Search",
      available: "Available",
      notAvailable: "Not avaliable",
      noResults: "No results were found \n" +
        "for your query",
      noResultsShort: "No results found",
      tryChangingTheRequest: "Try changing the request",
      typesOfAnamnesis: "Types of anamnesis",
      toStartTheConsultation: "To start the consultation, choose its type",
      selectTheTypeOfAnamnesis: "Select the type of anamnesis",
      addToCompare: "Add to compare",
      filters: "Filters",
      characteristics: "Characteristics",
      company: "Company",
      pharmaceuticalDoseForms: "Pharmaceutical dose forms",
      activeIngredients: "Active ingredients",
      routesOfAdministration: "Routes of administration",
      strength: "Strength",
      excipients: "Excipients",
      atcCodes: "Atccodes",
      selectTypeOfAnamnesis: "Select the type of anamnesis",
      removeFromInteractions: "Remove from interactions",
      danaAssist: "Dana Assist",
      doYouHaveAQuestionForMe: "Do you have a question for me?",
      diagnosticImaging: "Diagnostic imaging",
      medicalCalculators: "Medical Calculators",
      treatmentFormulation: "Treatment Formulation",
      differentialCaseDiagnosis: "Differential case diagnosis",
      laboratoryResultsInterpretation: "Laboratory results interpretation",
      message: "Message",
      deleteNote: "Delete note",
      comparison: "Comparison",
      toStartComparisonSelectMedicines: "To start the comparison, select medicines",
      goToComparison: "Go to comparison",
      addMedicinesToCompare: "Add medicines to compare",
      noInteractionsDescribed: "There are no interactions described for this combination",
      highDanger: "High danger",
      mediumDanger: "Medium danger",
      lowDanger: "Low danger",
      effect: "Effect",
      importance: "Importance",
      mechanism: "Mechanism",
      informationSource: "Information source",
      objectives: "Objectives",
      links: "Links",
      anamnesis: "Anamnesis",
      turnOffNotifications: "Turn off notifications",
      turnOnNotifications: "Turn on notifications",
      blockThePatient: "Block the patient",
      unBlockThePatient: "Unblock the patient",
      shareAnamnesis: "Share anamnesis",
      email: "Email",
      hasUnfinishedAnamnesis: "Has unfinished anamnesis",
      continueAnamnesis: "Continue anamnesis",
      acceptChange: "Accept change",
      endAnamnesis: "End anamnesis",
      addPatientToChat: "Add a patient to the chat",
      startChatWithPatient: "To start a chat with a patient,\n find them by phone or SIP number",
      or: "or",
      patientNotFound: "Patient not found",
      giveNameToPatient: "You can give a name to the patient",
      selectPatientToCompleteAppointment: "Select a patient to complete the appointment",
      skip: "Skip",
      surname: "Surname",
      specialtyExternalConsultationReport: "Specialty External Consultation Report",
      primaryCareClinicalReport: "Primary Care Clinical Report",
      emergencyReport: "Emergency Report",
      summaryClinicalHistory: "Summary Clinical History",
      firstVisitDetailedSoap: "First Visit (Detailed SOAP)",
      firstVisitConciseSoap: "First Visit (Concise SOAP)",
      successiveVisitsEvolution: "Successive Visits (Evolution)",
      nursingCareReport: "Nursing Care Report",
      socialWorkerReport: "Social Worker Report",
      recipe: "Recipe",
      settings: "Settings",
      theme: "Theme",
      language: "Language",
      changePhone: "Change phone number",
      pinChange: "PIN change",
      signOut: "Sign out",
      numberChange: "Number change",
      enterCurrentPhoneForVerification: "Enter your current phone number for verification",
      en: "English",
      pt: "Portuguese",
      ua: "Ukrainian",
      es: "Spanish",
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;